import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateAccountForm from '../../forms/CreateOrUpdateAccountForm'

interface CreateAccountModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateAccountModal: React.FC<CreateAccountModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => (
  <AppModal open={open} onClose={onClose} title="Create New Account" width="md" loading={loading}>
    <CreateOrUpdateAccountForm loading={loading} error={error} />
  </AppModal>
)

export default CreateAccountModal
